import { render, staticRenderFns } from "./TabBar.vue?vue&type=template&id=24003b2b&scoped=true"
import script from "./TabBar.vue?vue&type=script&lang=ts"
export * from "./TabBar.vue?vue&type=script&lang=ts"
import style0 from "./TabBar.vue?vue&type=style&index=0&id=24003b2b&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24003b2b",
  null
  
)

export default component.exports